import { render, staticRenderFns } from "./wj.vue?vue&type=template&id=5a4987b4&scoped=true"
import script from "./wj.vue?vue&type=script&lang=js"
export * from "./wj.vue?vue&type=script&lang=js"
import style0 from "./wj.vue?vue&type=style&index=0&id=5a4987b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4987b4",
  null
  
)

export default component.exports